module.exports = __webpack_public_path__ + "cec1a83bebc413feae005a223562c5e1.png";